var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.677,
    height: 24.677,
    viewBox: "0 0 24.677 24.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1664",
    "data-name": "Group 1664",
    transform: "translate(-38.614 -612.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447",
    transform: "translate(38.614 612.682)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 12.339,
    cy: 12.339,
    r: 12.339,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448",
    transform: "translate(-664.547 3021.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M708.235-2398.832a1.581,1.581,0,0,1,.358-.742,1.4,1.4,0,0,1,.889-.447,1.018,1.018,0,0,0,.234-.064l8.5-3.174a.837.837,0,0,1,1.134.54q.441,1.3.878,2.6a.174.174,0,0,0,.146.134,1.367,1.367,0,0,1,1.064,1.306c.007.365,0,.731,0,1.1a.274.274,0,0,1-.313.307,1.567,1.567,0,0,0-.717.115,1.105,1.105,0,0,0-.61,1.137,1.089,1.089,0,0,0,.954.94c.136.016.274.01.412.017a.256.256,0,0,1,.269.243,12.674,12.674,0,0,1-.026,1.365,1.328,1.328,0,0,1-1.265,1.135c-.163.006-.327,0-.49,0H709.74a1.377,1.377,0,0,1-1.49-1.173c0-.007-.01-.013-.015-.02v-1.367a.358.358,0,0,1,.373-.189,1.682,1.682,0,0,0,.321-.013,1.089,1.089,0,0,0,.942-.921,1.1,1.1,0,0,0-.587-1.147,1.282,1.282,0,0,0-.676-.12.363.363,0,0,1-.374-.189Zm12.65,4.316a1.665,1.665,0,0,1-1.64-1.529,1.624,1.624,0,0,1,.338-1.134,1.667,1.667,0,0,1,1.309-.653c0-.254,0-.5,0-.743a.833.833,0,0,0-.9-.9h-6.807c0,.1,0,.182,0,.263a.272.272,0,0,1-.272.283.266.266,0,0,1-.274-.278c0-.085,0-.17,0-.253a.248.248,0,0,0-.049-.015c-1.014,0-2.029-.006-3.043,0a.767.767,0,0,0-.737.646,9.418,9.418,0,0,0-.007.988,1.688,1.688,0,0,1,1.634,1.669,1.694,1.694,0,0,1-1.655,1.657c0,.247,0,.5,0,.744a.833.833,0,0,0,.893.895h2.963c0-.1,0-.183,0-.268a.266.266,0,0,1,.273-.279.271.271,0,0,1,.273.282c0,.084,0,.169,0,.264h6.844a.806.806,0,0,0,.849-.747C720.906-2393.913,720.885-2394.211,720.885-2394.515Zm-1.22-5.517a.556.556,0,0,0-.014-.082q-.415-1.225-.832-2.449a.278.278,0,0,0-.4-.186c-.23.083-.458.171-.687.257l-6.412,2.4c-.039.015-.076.032-.114.048l.01.016Z",
    transform: "translate(0 0)",
    fill: "#8c63ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M836.59-2250.374c0,.146,0,.292,0,.438a.275.275,0,0,1-.279.29.27.27,0,0,1-.266-.288q-.005-.451,0-.9a.276.276,0,0,1,.277-.291.278.278,0,0,1,.268.289C836.592-2250.683,836.59-2250.529,836.59-2250.374Z",
    transform: "translate(-123.403 -146.953)",
    fill: "#8c63ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M836.056-2182.735c0-.15,0-.3,0-.451a.27.27,0,0,1,.266-.287.272.272,0,0,1,.28.288q0,.451,0,.9a.275.275,0,0,1-.28.289.279.279,0,0,1-.266-.29c0-.009,0-.017,0-.026Q836.056-2182.522,836.056-2182.735Z",
    transform: "translate(-123.417 -212.276)",
    fill: "#8c63ee"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketsIcon);
export default __webpack_public_path__ + "static/media/TicketsIcon.256917ca09a816409ebc96d12ef413a1.svg";
export { ForwardRef as ReactComponent };